// src/services/sitesService.ts
import { apiService } from './api';

export interface LightsailBlueprint {
  id: string;
  name: string;
  description: string;
  version: string;
  platform: string;
  group: string;
}

export interface LightsailBundle {
  id: string;
  name: string;
  price: number;
  cpuCount: number;
  ramSizeInGb: number;
  diskSizeInGb: number;
  transferPerMonthInGb: number;
}

export interface BlueprintsResponse {
  ok: boolean;
  blueprints: LightsailBlueprint[];
}

export interface BundlesResponse {
  ok: boolean;
  bundles: LightsailBundle[];
}

export class SitesService {
  private baseEndpoint = '/products';

  async getBlueprints(): Promise<BlueprintsResponse> {
    return apiService.get<BlueprintsResponse>(`${this.baseEndpoint}/blueprints`);
  }

  async getBundles(): Promise<BundlesResponse> {
    return apiService.get<BundlesResponse>(`${this.baseEndpoint}/bundles`);
  }
}

export const sitesService = new SitesService();